<template lang="pug">
.bq-sidenav(:class="{ mobile: isMobile }")
    .bq-sidenav-top
        router-link.bq-back-link.bq-cta-link(
            to="/my-projects"
            @click="emit('closeMobileMenu')"
        )
            span.bq-arrow.bq-arrow--lead(translate="no") &larr;
            | My Projects

        nav.bq-nav

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/agent`"
                :class="{ active: route.name === 'agent' }"
                data-track="sideNav_agent"
                @click="emit('closeMobileMenu')"
            )
                span Query
                img.bq-nav-icon-img(src="/bunnyquery-logo-cut-sm.png" alt="" aria-hidden="true")

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/dbfile`"
                :class="{ active: route.name === 'dbfile' }"
                data-track="sideNav_db_files"
                @click="emit('closeMobileMenu')"
            )
                span Files
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") file_present

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}/users`"
                :class="{ active: route.name === 'users' }"
                data-track="sideNav_users"
                @click="emit('closeMobileMenu')"
            )
                span Collaborators
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") group_add

            //- router-link.bq-nav-item(
            //-     :to="`/my-projects/${currentService.id}/records`"
            //-     :class="{ active: route.name === 'records' }"
            //-     data-track="sideNav_records"
            //-     @click="emit('closeMobileMenu')"
            //- ) Database

            router-link.bq-nav-item(
                :to="`/my-projects/${currentService.id}`"
                :class="{ active: route.name === 'dashboard' || route.name === 'records' }"
                data-track="sideNav_service_settings"
                @click="emit('closeMobileMenu')"
            )
                span Settings
                span.material-symbols-outlined.bq-nav-icon(translate="no" aria-hidden="true") settings
            
            //- router-link.bq-nav-item(
            //-     :to="`/my-projects/${currentService.id}/hosting`"
            //-     :class="{ active: route.name === 'hosting' }"
            //-     data-track="sideNav_file_hosting"
            //-     @click="emit('closeMobileMenu')"
            //- ) Hosting

            //- router-link.bq-nav-item(
            //-     :to="`/my-projects/${currentService.id}/clientsecret`"
            //-     :class="{ active: route.name === 'clientsecret' }"
            //-     data-track="sideNav_client_secret"
            //-     @click="emit('closeMobileMenu')"
            //- ) API Keys

</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { onMounted, onUnmounted, ref, computed } from "vue";
import { currentService } from "@/views/project-list";

const router = useRouter();
const route = useRoute();

const emit = defineEmits(["closeMobileMenu"]);
const isMobile = ref(false);

const checkMobile = () => {
    isMobile.value = window.innerWidth <= 800;
};

let will_cancel = computed(() => {
    if (!currentService.value) return false;
    const cancel_at = currentService.value.subscription?.cancel_at;
    return !!cancel_at || !!currentService.value.service?.will_terminate;
});

let canChangePlan = computed(() => {
    if (!currentService.value) return false;
    return !!currentService.value.formattedSpecs?.serviceStatus?.canChangePlan;
});

let planLabel = computed(() => {
    return currentService.value?.formattedSpecs?.currentPlan?.label || '';
});

let planClass = computed(() => {
    return (planLabel.value || '').toLowerCase().split(' ')[0];
});

const changeRoute = () => {
    emit("closeMobileMenu");
};

onMounted(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile);
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-sidenav {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    font-family: @mono;
    color: @ink;
    background: @paper;

    &.mobile {
        height: auto;
        border-right: none;
        border-bottom: 1px solid @line;

        .bq-sidenav-bottom {
            display: none;
        }
    }
}

.bq-sidenav-top {
    padding-top: 3rem;
}

// Layout only. Colour, underline and hover come from the shared .bq-cta-link;
// the arrow is a .bq-arrow so the underline stops before it.
.bq-back-link {
    display: inline-block;
    margin: 0 1.5rem 1rem;
    font-size: 0.82rem;
}

.bq-service-header {
    padding: 2rem 1.5rem 1.5rem;
    text-align: left;
}

.bq-service-name {
    margin-top: 0.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-nav {
    display: flex;
    flex-direction: column;
    // padding: 0.5rem 0;
}

.bq-nav-item {
    /* Label + icon on one row. Desktop pushes the icon to the RIGHT edge
       (space-between); the mobile pulldown flips to icon-on-the-LEFT via
       row-reverse below - markup order stays label-then-icon in both. */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.65rem 1.5rem;
    font-size: 0.85rem;
    color: @ink;
    text-decoration: none;
    transition: color 0.1s;
    border-right: 2px solid transparent;

    &:hover {
        color: @pink;
    }

    &.active {
        color: @pink;
        font-weight: 600;
        border-right-color: @pink;
        background: @pink-bg;
    }
}

.bq-sidenav-bottom {
    padding: 1.5rem;
    // border-top: 1px solid @line;
}

.bq-upgrade-link {
    display: block;
    text-align: center;
    padding: 0.6rem 1rem;
    border: 1px solid @ink;
    color: @ink;
    font-family: @mono;
    font-size: 0.82rem;
    text-decoration: none;
}

.bq-nav-icon {
    font-size: 1.05rem;
    opacity: 0.65;
}

.bq-nav-icon-img {
    width: 1.05rem;
    height: 1.05rem;
    object-fit: contain;
    // opacity: 0.85;
}

/* Mobile pulldown: icon leads the label. */
.bq-sidenav.mobile .bq-nav-item {
    flex-direction: row-reverse;
    justify-content: flex-end;
}
</style>
